import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";

import Evaluations from "../../../../components/ModuleComponents/Evaluations";
import Grades from "../../../../components/ModuleComponents/Grades";

const ModuleDetailPage = () => {
  const { id } = useParams<{ id: string }>();
  const [isLoading, setIsLoading] = useState(true);
  const [moduleDetails, setModuleDetails] = useState<any>(null);

  useEffect(() => {
    const token = localStorage.getItem("token");

    fetch(`https://has-backend-c48d669d897f.herokuapp.com/admin/modules/${id}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    })
      .then((response) => {
        if (!response.ok) throw new Error(`Error HTTP! Estado: ${response.status}`);
        return response.json();
      })
      .then((data) => {
        setModuleDetails(data);
        setIsLoading(false);
      })
      .catch((error) => {
        console.error("Error al cargar detalles del módulo:", error);
        setIsLoading(false);
      });
  }, [id]);

  return (
    <div className="min-h-screen w-full px-8 flex flex-col bg-gray-100">
      <div className="flex-1 overflow-y-auto py-8">
        {isLoading ? (
          <p>Cargando detalles...</p>
        ) : moduleDetails ? (
          <div className="flex flex-col items-start gap-8 w-full">
            <div className="w-full flex flex-col sm:flex-row justify-between items-start sm:items-center">
              <h2 className="font-playfair font-bold text-4xl">{moduleDetails.title}</h2>
              <h2 className="font-playfair font-bold text-2xl">Semana: {moduleDetails.week}</h2>
            </div>

            <div className="w-full">
              <h2 className="font-playfair font-bold text-4xl mt-8 mb-4">Evaluación</h2>
              <p className="font-bold font-sourceSans mb-2">Pregunta</p>
              <Evaluations moduleId={id!} />
            </div>

            <Grades />

            <div className="w-full">
              <h2 className="font-playfair font-bold text-4xl mt-8 mb-4">Guía de estudio</h2>
              <iframe
                src={`https://guiascontainer.s3.us-east-2.amazonaws.com/0${moduleDetails.week}.pdf`}
                width="100%"
                height="720px"
                className="border rounded-lg"
              />
            </div>
          </div>
        ) : (
          <p>No se encontró el módulo.</p>
        )}
      </div>
    </div>
  );
};

export default ModuleDetailPage;
